const content = {
  page_title: "Devices",
  //tabs: ["Journeys", "Messages"],
  tabs: [
    {
      value: "Journeys",
      label: "Journeys",
    },
    {
      value: "Messages",
      label: "Messages",
    },
  ],
  devices_overview_select: [
    {
      label: "Today",
      value: "1",
    },
    {
      label: "This Week",
      value: "7",
    },
    {
      label: "This Month",
      value: "30",
    },
  ],
  filters: {
    //primary: ["All", "Watchlist"],
    primary: [
      { label: "All", value: "All" },
      { label: "Watchlist", value: "Watchlist" },
      { label: "Back Online", value: "BackOnline" },
    ],
    secondary: {
      list_checkbox: [
        {
          label: "Message Type",
          value: "LastMessageType",
          values: ["TwoWiFi", "Gps", "DownlinkAcknowledgement", "DL Ack"],
        },
        {
          label: "Battery",
          value: "BatteryStatus",
          values: ["High", "Low", "Unknown"],
        },
        {
          label: "POI Type",
          value: "LocationType",
          values: ["Friendly", "Non Friendly", "Outside POIs", "No location data"],
        },
        {
          label: "Device Status",
          value: "DeviceStatus",
          values: ["Fluid", "Static"],
        },
        {
          label: "Asset Type",
          value: "AssetType",
          values: ["Owned", "Rented", "Others"],
        },
      ],
      flags: [
        {
          label: "Tampering Alerts",
          value: "TamperDate",
        },
      ],
    },
  },
  devices_table: [
    {
      align: "start",
      text: "Device ID",
      value: "DeviceID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Asset ID",
      value: "AssetID",
      of_type: "text",
    },
    {
      text: "Current POI",
      value: "CurrentPOI",
      of_type: "text",
    },
    {
      text: "POI Type",
      value: "LocationType",
      of_type: "text",
    },
    {
      text: "Stay Duration",
      value: "StayDuration",
      of_type: "hours",
    },
    {
      text: "M. Type",
      value: "LastMessageType",
      of_type: "secondary_icon",
    },
    {
      text: "Last Message",
      value: "LastMessageTime",
      of_type: "date",
    },
    {
      text: "Battery",
      value: "BatteryStatus",
      of_type: "text",
    },
    {
      text: "Device Status",
      value: "DeviceStatus",
      of_type: "text",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  devices_back_online_table: [
    {
      align: "start",
      text: "Device ID",
      value: "DeviceID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Entry Time",
      value: "EntryTime",
      of_type: "date",
    },
    {
      text: "Last Seen Location",
      value: "LastSeenLocation",
      of_type: "text",
    },
    {
      text: "Previous Last Seen",
      value: "PrevLastSeen",
      of_type: "date",
    },
    {
      text: "Last Message Type",
      value: "LastMessageType",
      of_type: "secondary_icon",
    },
    {
      text: "Time Gap",
      value: "TimeGap",
      of_type: "number",
    },
  ],
  messages_table: [
    {
      align: "start",
      text: "Seq No",
      value: "SeqNo",
      sortable: true,
      of_type: "text",
    },
    {
      text: "Current POI",
      value: "FullName",
      of_type: "text",
    },
    {
      text: "POI Accuracy",
      value: "LocationAccuracy",
      of_type: "number",
      decimal: -1,
    },
    {
      text: "Message Time",
      value: "MessageTime",
      of_type: "date",
    },
    {
      text: "Latitude",
      value: "Latitude",
      of_type: "number",
      decimal: 8,
    },
    {
      text: "Longitude",
      value: "Longitude",
      of_type: "number",
      decimal: 8,
    },
    {
      text: "M. Type",
      value: "MessageType",
      of_type: "secondary_icon",
    },
    {
      text: "LQI",
      value: "Lqi",
      of_type: "text",
    },
    {
      text: "",
      value: "mdi-map-marker-circle",
      sortable: false,
      of_type: "action",
      condition: "Latitude",
    },
  ],
  journeys_table: [
    {
      align: "start",
      text: "Last Seen Message",
      value: "LastSeenTime",
      sortable: true,
      of_type: "date",
    },
    {
      text: "Current POI",
      value: "LastLocation",
      of_type: "text",
    },
    {
      text: "M. Type",
      value: "LastMessageType",
      of_type: "secondary_icon",
    },
  ],
  battery_status: {
    title: "Assets Battery",
    header: [
      "Battery Status",
      "Number of Assets",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "High Battery",
        value: "High",
        msg: "Assets with high battery.",
      },
      {
        label: "Low Battery",
        value: "Low",
        msg: "Assets with low battery.",
      },
      {
        label: "Unknown Battery",
        value: "Unknown",
        msg: "Assets with unknown battery.",
      },
      {
        label: "No Battery",
        value: "null",
        msg: "Assets with no battery.",
      },
    ],
  },
  connection_status: {
    title: "Assets Communication",
    header: [
      "Connectivity",
      "Number of Assets",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Communicated",
        value: "connected",
        msg: "Assets communicated in last 72 hours",
      },
      {
        label: "No Communication",
        value: "notConnected",
        msg: "Assets not communicated in last 72 hours",
      },
    ],
  },
  message_type: {
    title: "Message Type",
    header: [
      "Message Type",
      "Number of Assets",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "TwoWifi",
        value: "TwoWifi",
        msg: "Assets communicated via TwoWifi",
      },
      {
        label: "Gps",
        value: "Gps",
        msg: "Assets communicated via Gps",
      },
      {
        label: "OneWiFi",
        value: "OneWiFi",
        msg: "Assets communicated via OneWiFi",
      },
      {
        label: "None",
        value: "None",
        msg: "No message type",
      },
      {
        label: "Others",
        values: ["twowifi", "gps", "onewifi", "none"],
        msg: "Other message types",
      },
    ],
  },
  maps_config: {
    id: "SeqNo",
    label: "SeqNo",
    lat: "Latitude",
    lng: "Longitude",
    infoText: "FullName",
    type: "marker",
  },
  maps__journey_config: {
    id: "id",
    label: "LastLocation",
    lat: "LastLat",
    lng: "LastLng",
    infoText: "LastLocation",
    type: "marker",
  },
  asset_types: ["Owned", "Rented", "Others"],
};
export { content };
